/** Single “how to use this screen” hints (paired with useGuidedHints oneShotInteractionHint). */

export const TAP_ON_IMAGE_ONE_SHOT = {
  text: 'Tap the dashed circles or boxes right on the picture. A checkmark means that spot was right. A quick red flash means try a different spot — wrong taps clear so you can keep exploring.',
  audioText:
    'Tap the dashed circles or boxes right on the picture. A checkmark means that spot was right. A quick red flash means try a different spot. Wrong taps clear so you can keep exploring.',
};

export const EXPLORATION_CARD_ONE_SHOT = {
  text: 'Tap Next card to read each stop on the tour. At the end, tap Finish tour.',
  audioText:
    'Tap Next card to read each stop on the tour. At the end, tap Finish tour.',
};

/** SequenceEngine tap-first — mechanics; full line may append content.instructions when it is UI-only. */
export const SEQUENCE_ORDER_ONE_SHOT = {
  text: 'Tap the steps in the order they should happen. Tap a numbered step to undo from there.',
  audioText:
    'Tap the steps in the order they should happen. Tap a numbered step to undo from there.',
};

export const GEAR_RATIO_ONE_SHOT = {
  text: 'Tap a gear size below the motor to change the driven gear. Watch the speed readout — in challenge mode, hold the match until it locks in. Bigger driven gear usually means slower output.',
  audioText:
    'Tap a gear size below the motor to change the driven gear. Watch the speed readout. In challenge mode, hold the match until it locks in. Bigger driven gear usually means slower output.',
};

export const CIRCUIT_BUILDER_ONE_SHOT = {
  text: 'Tap two gold terminals on the board to draw a wire. In the lesson, tap Check when you think the LED can glow — feedback shows after Check.',
  audioText:
    'Tap two gold terminals on the board to draw a wire. In the lesson, tap Check when you think the LED can glow. Feedback shows after Check.',
};

export const SIMULATION_SCRUB_ONE_SHOT = {
  text: 'Use Previous and Next (or + and −) to move through the scene. When it matches the goal, tap Check answer.',
  audioText:
    'Use Previous and Next, or plus and minus, to move through the scene. When it matches the goal, tap Check answer.',
};

export const GEAR_DIRECTION_ONE_SHOT = {
  text: 'Use Start as the direction reference — tap the other gears that match the prompt, then Check. The train spins after you Check.',
  audioText:
    'Use Start as the direction reference. Tap the other gears that match the prompt, then Check. The train spins after you Check.',
};

export const GEAR_SPEED_ONE_SHOT = {
  text: 'Use tooth labels when shown. Pick your answer, then Check below — on fastest/slowest steps the train spins after Check.',
  audioText:
    'Use tooth labels when the activity shows them. Pick your answer, then Check below. On fastest or slowest steps, the train spins after you Check.',
};

export const CIRCUIT_PATH_ONE_SHOT = {
  text: 'Tap each dashed gap to cycle pieces until the path looks right, then tap Check below — the bulb glows only after Check.',
  audioText:
    'Tap each dashed gap to cycle pieces until the path looks right, then tap Check below. The bulb glows only after you tap Check.',
};

export const SWITCH_LOGIC_ONE_SHOT = {
  text: 'Tap switches to flip ON or OFF. On AND steps the output stays dark until you tap Check below; OR steps preview live. Tap Check when your pattern matches the goal.',
  audioText:
    'Tap switches to flip ON or OFF. On AND steps the output stays dark until you tap Check below. OR steps preview live. Tap Check when your pattern matches the goal.',
};

export const SYSTEM_FLOW_ONE_SHOT = {
  text: 'Use the side arrows to slide each part earlier or later in the chain. When the story order matches the mission, tap Run system and watch the signal travel.',
  audioText:
    'Use the side arrows to slide each part earlier or later in the chain. When the story order matches the mission, tap Run system and watch the signal travel.',
};

export const VARIABLE_SIMULATION_ONE_SHOT = {
  text: 'Tap + and − or the value control to change the picture. Read the captions. Tap Check when you hit the goal (or Done exploring if there is no target number).',
  audioText:
    'Tap plus and minus or the value control to change the picture. Read the captions. Tap Check when you hit the goal, or Done exploring if there is no target number.',
};

export const EVIDENCE_DETECTIVE_ONE_SHOT = {
  text: 'Tap each clue card to reveal it. Some wrong answers may gray out after enough clues. Pick your best answer, then tap Submit answer.',
  audioText:
    'Tap each clue card to reveal it. Some wrong answers may gray out after enough clues. Pick your best answer, then tap Submit answer.',
};
